import { useContext, useRef, useState } from "react";
import Slider from "react-slick";
import { AppContext } from "../App";
import banner1 from "../assets/banner1.png";
import banner2 from "../assets/fumigation.png";
import banner3 from "../assets/desk_accessories.png";

const slides = [
  {
    image: banner1,
    title: "Transforming supply into a simpler, more dependable experience.",
    buttonLabel: "Explore Services",
    target: "services",
  },
  {
    image: banner2,
    title:
      "A focused corporate partner for public health and workplace support.",
    buttonLabel: "About VEX",
    target: "about_us",
  },
  {
    image: banner3,
    title:
      "Professional sourcing, cleaner presentation, and responsive delivery.",
    buttonLabel: "Contact Us",
    target: "contact_us",
  },
];

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [activeSlide, setActiveSlide] = useState(0);
  const [progressKey, setProgressKey] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6500,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    beforeChange: (_, next) => {
      setActiveSlide(next);
      setProgressKey((key) => key + 1);
    },
  };

  return (
    <section className="vex-hero-section">
      <Slider ref={sliderRef} {...settings} className="vex-hero-slider">
        {slides.map((slide) => (
          <div className="vex-hero-slide" key={slide.title}>
            <div
              className="vex-hero-slide-bg"
              style={{ backgroundImage: `url(${slide.image})` }}
            />
            <div className="vex-hero-slide-overlay" />

            <div className="container vex-hero-layout">
              <div className="vex-hero-slide-content">
                <h1 className="vex-hero-title">{slide.title}</h1>
                <div className="vex-hero-actions">
                  <button
                    type="button"
                    className="btn btn-primary vex-btn vex-hero-slide-button"
                    onClick={() => appContext.navTo({ item: slide.target })}
                  >
                    <span>{slide.buttonLabel}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <div className="vex-hero-counter">
        <span className="vex-hero-counter-num">
          {String(activeSlide + 1).padStart(2, "0")}
        </span>
        <div className="vex-hero-counter-track">
          <div key={progressKey} className="vex-hero-counter-fill" />
        </div>
        <span className="vex-hero-counter-num vex-hero-counter-total">
          {String(slides.length).padStart(2, "0")}
        </span>
      </div>

      <div
        className="vex-hero-dots"
        role="tablist"
        aria-label="Slide navigation"
      >
        {slides.map((slide, index) => (
          <button
            key={slide.title}
            type="button"
            role="tab"
            aria-selected={index === activeSlide}
            aria-label={`Go to ${slide.buttonLabel}`}
            className={`vex-hero-dot${index === activeSlide ? " active" : ""}`}
            onClick={() => sliderRef.current?.slickGoTo(index)}
          />
        ))}
      </div>
    </section>
  );
}
